import { useEffect, useState } from 'react';

const CURRENT_WORKSPACE_KEY = 'currentWorkspace';

export type CurrentWorkspaceManager = {
    currentWorkspaceId: string | null;
    setCurrentWorkspaceId: React.Dispatch<React.SetStateAction<string | null>>;
}

const useCurrentWorkspace = (): CurrentWorkspaceManager => {
    const [currentWorkspaceId, setCurrentWorkspaceId] = useState<string | null>(() => {
        try {
            const saved = localStorage.getItem(CURRENT_WORKSPACE_KEY);
            if (saved) {
                const workspaceId = JSON.parse(saved);
                return workspaceId;
            }
        } catch (error) {
            console.error('Error loading workspace from localStorage:', error);
            localStorage.removeItem(CURRENT_WORKSPACE_KEY);
        }
        return null;
    });

    useEffect(() => {
        try {
            if (currentWorkspaceId)
                localStorage.setItem(CURRENT_WORKSPACE_KEY, JSON.stringify(currentWorkspaceId));
            else
                localStorage.removeItem(CURRENT_WORKSPACE_KEY);
        } catch (error) {
            console.error('Error saving workspace to localStorage:', error);
        }
    }, [currentWorkspaceId]);

    return {
        currentWorkspaceId,
        setCurrentWorkspaceId
    };
};

export default useCurrentWorkspace;